(function () {
  'use strict';

  /* @ngdoc object
   * @name parcels.delete
   * @description
   *
   */
  angular
    .module('parcels.delete', []);
}());
